import React from "react";
import classNames from "classnames";

import styles from "./Spinner.css";

export default function Spinner(props) {
  return React.createElement(
    "div",
    { className: !props.noContainer && styles.container },
    React.createElement(
      "div",
      { className: styles.root },
      Array.from(Array(8)).map(function (x, i) {
        return React.createElement("div", {
          key: i,
          className: classNames(styles["node-" + i], styles.node),
          style: {
            left: 15 * Math.cos(-0.25 * Math.PI * i) + "px",
            top: 15 * Math.sin(-0.25 * Math.PI * i) + "px"
          }
        });
      })
    )
  );
}


// WEBPACK FOOTER //
// ./src/components/Library/Spinner/Spinner.js